/** USD formatter; sub-dollar amounts keep 4 decimals so a $0.017 per-product cost stays legible. */
export function formatUsd(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: Math.abs(amount) < 1 ? 4 : 2,
  }).format(amount);
}
